import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { LIVE_SUBSCRIPTION_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, LIVE_SUBSCRIPTION_TRANSLATION_KEY, {
  CONFIRMATION_DIALOG_SUCCESS_TITLE: 'Inscrição confirmada',
  CONFIRMATION_DIALOG_SUCCESS_DESCRIPTION: 'Nós lhe mandaremos um e-mail quando a transmissão ao vivo começar :)',
  CONFIRMATION_DIALOG_SUCCESS_DESCRIPTION_WITH_CALENDAR: 'Nós lhe mandaremos um e-mail quando a transmissão ao vivo começar. Sugerimos que adicione a live ao seu calendário :)',
  CONFIRMATION_DIALOG_ERROR_TITLE: 'Ops! Houve um erro',
  CONFIRMATION_DIALOG_ERROR_DESCRIPTION: 'Não pudemos realizar a inscrição :(',
  OK_BUTTON_LABEL: 'Entendi!',
  CALENDAR_BUTTON_LABEL: 'Adicionar ao calendário',
  RETRY_BUTTON_LABEL: 'Tentar novamente'
});